$(function () {

    let $ = require('jquery');
    let jQueryBridget = require('jquery-bridget');
    let Masonry = require('masonry-layout');
    let imagesLoaded = require('imagesloaded');

    // make Masonry + imagesLoaded a jQuery plugin
    jQueryBridget('masonry', Masonry, $);
    jQueryBridget('imagesLoaded', imagesLoaded, $);
 
    let $container = $('.news-list').imagesLoaded(function () {
        $container.masonry({
            columnWidth: '.news',
            gutter: 16,
            itemSelector: '.news',
            percentPosition: true,
            transitionDuration: 0
        });
    });

});



// WEBPACK FOOTER //
// ./assets/app/js/masonry-layout/index.js